import { useState, useEffect } from 'react';
import { FILTER_DEFAULTS, SEARCH_DEBOUNCE_MS } from '../utils/reportConstants';

export const useReportFilters = () => {
  const [searchTerm, setSearchTerm] = useState(FILTER_DEFAULTS.search);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(FILTER_DEFAULTS.search);
  const [statusFilter, setStatusFilter] = useState(FILTER_DEFAULTS.status);
  const [technicianFilter, setTechnicianFilter] = useState(FILTER_DEFAULTS.technician);

  // Debounce search term
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  const hasActiveFilters = () => {
    return searchTerm || statusFilter || technicianFilter;
  };

  const clearAllFilters = () => {
    setSearchTerm(FILTER_DEFAULTS.search);
    setStatusFilter(FILTER_DEFAULTS.status);
    setTechnicianFilter(FILTER_DEFAULTS.technician);
  };

  return {
    // Current filter values
    searchTerm,
    debouncedSearchTerm,
    statusFilter,
    technicianFilter,
    
    // Filter setters
    setSearchTerm,
    setStatusFilter,
    setTechnicianFilter,
    
    // Utilities
    hasActiveFilters,
    clearAllFilters
  };
};